export default [
	{  // 【服务】-【Banner】
		path: 'website/service/banner',
		name: 'm_service_banner',
		meta: {
			title: '服务Banner'
		},
		component: () => import('@/pages/website/service/service_banner')
	},
	{  // 【服务】-【定制服务】
		path: 'website/service/custom/list',
		name: 'm_custom',
		meta: {
			title: '定制服务列表'
		},
		component: () => import('@/pages/website/service/custom_list')
	},{  //定制服务详情
		path: 'website/service/custom/detail/:id',
		name: 'custom_detail',
		meta: {
			title: '定制服务详情'
		},
		props: route => route.params,
		component: () => import('@/pages/website/service/custom_detail')
	},
	{  // 【服务】-【文件】
		path: 'website/service/file/list',
		name: 'm_file',
		meta: {
			title: '文件列表'
		},
		component: () => import('@/pages/website/service/file_list')
	}
];